import { atom } from 'jotai';
import { REVIEW_FEATURES } from '../constants';
import { DEFAULT_REVIEW_FEATURE_CONFIG } from '../default-feature-config';
import type { ReviewFeaturesT } from '../types';
export const featuresAtom = atom<ReviewFeaturesT>(DEFAULT_REVIEW_FEATURE_CONFIG);
export const showClassificationActionPanelAtom = atom<boolean>(get => {
  const features = get(featuresAtom);
  return !features[REVIEW_FEATURES.ENABLE_CONTINUOUS_PLAYBACK];
});
export const isFocusedModeEnabledAtom = atom<boolean>(false);